import { render, staticRenderFns } from "./GridItemBig.vue?vue&type=template&id=2c271cdc&scoped=true&"
import script from "./GridItemBig.vue?vue&type=script&lang=js&"
export * from "./GridItemBig.vue?vue&type=script&lang=js&"
import style0 from "./GridItemBig.vue?vue&type=style&index=0&id=2c271cdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c271cdc",
  null
  
)

export default component.exports